import { useEffect, useState } from 'react';
import { getCookieConsent } from '../utils/cookieConsent';

export const GYG_ANALYTICS_SRC = 'https://widget.getyourguide.com/dist/pa.umd.production.min.js';
export const GYG_ANALYTICS_SCRIPT_ID = 'eco-getyourguide-partner-analytics';
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const mayLoadGetYourGuideAnalytics = (config, consent) => Boolean(config?.enabled && config?.partnerId && consent?.categories?.marketing === true);

export function syncGetYourGuideAnalytics(config, consent, documentRef = document) {
  const existing = documentRef.getElementById(GYG_ANALYTICS_SCRIPT_ID);
  if (!mayLoadGetYourGuideAnalytics(config, consent)) { existing?.remove(); return false; }
  if (existing) return true;
  const script = documentRef.createElement('script');
  script.id = GYG_ANALYTICS_SCRIPT_ID; script.async = true; script.defer = true; script.src = GYG_ANALYTICS_SRC;
  script.dataset.gygPartnerId = config.partnerId;
  documentRef.head.appendChild(script);
  return true;
}

export function GetYourGuideAnalytics() {
  const [config, setConfig] = useState(null); const [consent, setConsent] = useState(() => getCookieConsent());
  useEffect(() => { fetch(`${API}/external-travel-partners/getyourguide-analytics`).then((response) => response.ok ? response.json() : null).then(setConfig).catch(() => setConfig(null)); }, []);
  useEffect(() => { const update = (event) => setConsent(event.detail || getCookieConsent()); window.addEventListener('eco:cookie-consent-changed', update); return () => window.removeEventListener('eco:cookie-consent-changed', update); }, []);
  useEffect(() => { if (config) syncGetYourGuideAnalytics(config, consent); }, [config, consent]);
  return null;
}
